import { render, staticRenderFns } from "./assetImportLogList.vue?vue&type=template&id=707d8ab3&scoped=true"
import script from "./assetImportLogList.vue?vue&type=script&lang=js"
export * from "./assetImportLogList.vue?vue&type=script&lang=js"
import style0 from "./assetImportLogList.vue?vue&type=style&index=0&id=707d8ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d8ab3",
  null
  
)

export default component.exports